import React from "react";
import { useState, useEffect, useRef } from "react";
import ExceptionVariables from '../JSON Files/ExceptionVariables.json'
import maskedBrandOption from '../JSON Files/MaskedBrandOption.json'
import unMaskedBrandOption from '../JSON Files/MaskedBrandOption.json'
import Loader from "react-js-loader";
import { Link } from "react-router-dom";
import Select, { components } from "react-select";
import { useDispatch } from "react-redux";
import UserService from "../../services/UserService"; import AuthService from "../../services/AuthService";
import getNotification from "../../Redux/Action/action";
import axios from "axios";
import FooterPages from "../Footer/FooterPages";
import Chart from "react-apexcharts";
import Navbar3 from "../Navbars/Navbar3";
import SubNavbar from "../Navbars/SubNavbar";

import SingleBarChart4 from "../Simulator/SingleBarChart4";
import SingleBarChart5 from "../Simulator/SingleBarChart5";
import SingleBarChart6 from "../Simulator/SingleBarChart6";

import SingleBarChart1 from "../Simulator/SingleBarChart1";
import SingleBarChart2 from "../Simulator/SingleBarChart2";
import SingleBarChart3 from "../Simulator/SingleBarChart3";
import PieCharts from "../Simulator/PieCharts";
import SingleBarChart7 from "../Simulator/SingleBarChart7";
import SingleBarChart8 from "../Simulator/SingleBarChart8";

import LineChart1 from "../Simulator/LineChart1";
import AnnualData from "../Simulator/AnnualData";

const { REACT_APP_REDIRECT_URI } = process.env;
const { REACT_APP_UPLOAD_DATA } = process.env;
const { REACT_APP_UPLOAD_DATA2 } = process.env;
const XLSX = require("xlsx");
function SavedScenarios() {
  const [referencescenarioname, setreferencescenarioname] = useState([])
  const [masterscenariotimestamp, setmasterscenariotimestamp] = useState("")
  const fileInputRef = useRef(null);
  const fileInputRef2 = useRef(null);
  const dispatch = useDispatch();
  const [createfrombaseoruploadfileswitch, setcreatefrombaseoruploadfileswitch] = useState(false)
  const [fulldataset, setfulldataset] = useState({})
  const [fulldataset2, setfulldataset2] = useState({})
  const [timetype, settimetype] = useState("")
  const [mape, setmape] = useState(0)
  const [isValue, setisValue] = useState(false)
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState("")
  const [predictedsalesvaluelastfy, setpredictedsalesvaluelastfy] = useState(0)
  const [originaldatasetforcolorcoding, setoriginaldatasetforcolorcoding] = useState([])
  const [yearoptions, setyearoptions] = useState([])
  const [modifybtn, setmodifybtn] = useState(false)
  const [fromrangeonplots, setfromrangeonplots] = useState("")
  const [marketoptions, setmarketoptions] = useState([])
  const [uploadfile, setuploadfile] = useState("")
  const [market, setmarket] = useState("");
  const [options1, setoptions1] = useState({})
  const [plotdata1, setplotdata1] = useState([]);
  const [loader, setloader] = useState(false);
  const [loader1, setloader1] = useState(false);
  const [loader2, setloader2] = useState(false);
  const [loader3, setloader3] = useState(false);
  const [loader4, setloader4] = useState(false);
  const [loader5, setloader5] = useState(false);
  const [scenariooptions, setscenariooptions] = useState([]);
  const [scenarionewoldscreen, setscenarionewoldscreen] = useState("Select")
  const [viewscenariobtn, setviewscenariobtn] = useState(false)
  const [viewscenariodatatable, setviewscenariodatatable] = useState(false)
  const [viewscenariodatatable2, setviewscenariodatatable2] = useState(false)
  const [newscenariofile, setnewscenariofile] = useState("")
  const [isHovered, setIsHovered] = useState(true);
  const [torangeonplots, settorangeonplots] = useState("")
  const [brandoptions, setbrandoptions] = useState([
  ]);
  const [displaynames, setdisplaynames] = useState({});
  const [displaynames2, setdisplaynames2] = useState({});

  const [edit, setedit] = useState([]);
  const [selectedzone, setselectedzone] = useState("National")
  const [selectedbrand, setselectedbrand] = useState("");
  const [selectedscenarioname, setselectedscenarioname] = useState("");
  const [selectedscenarioid, setselectedscenarioid] = useState("");
  const [selectedscenarionametimestamp, setselectedscenarionametimestamp] =
    useState("");
  const [selectedyear, setselectedyear] = useState("");
  const [resultscreen, setresultscreen] = useState(false);
  const [resultscreen2, setresultscreen2] = useState(false);
  const [newscenarionamegiven, setnewscenarionamegiven] = useState("");
  const [originalset, setoriginalset] = useState([]);
  const [sampledataset, setsampledataset] = useState(
    []);

  const sectionRef = useRef(null);
  const [monthlist, setmonthlist] = useState(["April", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec", "Jan", "Feb", "March"])
  useEffect(() => {
    handlevariablesfetchfybrand()
  }, []);
  useEffect(() => {
    handlefetchmarket()
  }, [selectedbrand])

  const today1 = new Date();
  const currentYear = today1.getFullYear();
  const currentMonth = today1.getMonth();

  let unblockeddate;


  if (currentMonth === 3) {

    unblockeddate = new Date(currentYear, currentMonth, 1);
  } else if (currentMonth >= 4) {

    unblockeddate = new Date(currentYear, currentMonth - 1, 1);
  } else {

    unblockeddate = new Date(currentYear - 1, 10, 1);
  }

  const MonthBeforeUnlockMonth = `${unblockeddate.getFullYear()}-${String(unblockeddate.getMonth() + 1).padStart(2, "0")}`;
  const MonthBeforeUnlockMonthreverse = MonthBeforeUnlockMonth.split("-").reverse().join("-");

  const formatDate = (dateString) => {
    const [month, year] = dateString.split("-");
    const date = new Date(`${year}-${month}-01`);
    return date.toLocaleString('default', { month: 'short', year: 'numeric' });
  };
  const scrollToSection = (sectionname) => {
    // Replace 'section2' with the id of the section you want to scroll to

    if (document.getElementById(sectionname)) {
      document
        .getElementById(sectionname)
        .scrollIntoView({ behavior: "smooth" });
    } else {
      dispatch(
        getNotification({
          message: "Please proceed with first analysis ",
          type: "Default",
        })
      );
    }
  };

  const handlevariablesfetchfybrand = async () => {
    if (UserService.isLoggedIn()) {
      try {
        const FormData = require("form-data");
        const sendData = new FormData();

        const config = {
          method: "get",
          url: `${REACT_APP_UPLOAD_DATA}/app/get_brand_fy`,
          headers: {
            Accept: "text/plain",
            "Content-Type": "application/json",
            // "req-header":UserService.getToken()
          },
          data: sendData,
        };
        const getResponse = await axios(config);
        // console.log(getResponse)
        if (getResponse.data !== "Invalid User!") {

          // setmarketoptions(
          //   getResponse.data.markets
          // );
          setyearoptions([
            ...(getResponse.data?.fy || []), // Use optional chaining to handle undefined/null values safely
            // Add the new fiscal year
          ]);

          setbrandoptions(
            getResponse.data.brands?.filter(it => !ExceptionVariables?.brandoptionshide?.includes(it?.brand))?.sort((a, b) => a.brand.localeCompare(b.brand))
          );
        }
      } catch (err) {
        console.log("Server Error", err);
        if (err.response && err.response.status === 500) {
          dispatch(
            getNotification({
              message: "Server is Down! Please try again after sometime",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 400) {
          dispatch(
            getNotification({
              message: "Input is not in prescribed format",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 422) {
          dispatch(
            getNotification({
              message: "Input is not in prescribed format",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 404) {
          dispatch(
            getNotification({
              message: "Page not Found",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 401) {
          dispatch(
            getNotification({
              message: "Session expired! Please log in again",
              type: "default",
            })
          );
        } else {
          dispatch(
            getNotification({
              message: "Server is Down! Please try again after sometime",
              type: "default",
            })
          );
        }
      }
    } else {
      setTimeout(() => {
        UserService.doLogin({
          redirectUri: `${REACT_APP_REDIRECT_URI}/simulator`,
        });
      }, 1000);
    }
  };
  const handlefetchmarket = async () => {
    if (UserService.isLoggedIn()) {
      try {
        const FormData = require("form-data");
        const sendData = new FormData();
        sendData.append("brand", selectedbrand)
        const config = {
          method: "post",
          url: selectedbrand === "ATTA" ? `${REACT_APP_UPLOAD_DATA}/app/atta_get_markets` : `${REACT_APP_UPLOAD_DATA}/app/get_markets`,
          headers: {
            Accept: "text/plain",
            "Content-Type": "application/json",
            // "req-header":UserService.getToken()
          },
          data: sendData,
        };
        const getResponse = await axios(config);
        // console.log(getResponse)
        if (getResponse.data !== "Invalid User!") {

          setmarketoptions(
            getResponse.data.markets
          );

        }
      } catch (err) {
        console.log("Server Error", err);
        if (err.response && err.response.status === 500) {
          dispatch(
            getNotification({
              message: "Server is Down! Please try again after sometime",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 400) {
          dispatch(
            getNotification({
              message: "Input is not in prescribed format",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 422) {
          dispatch(
            getNotification({
              message: "Input is not in prescribed format",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 404) {
          dispatch(
            getNotification({
              message: "Page not Found",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 401) {
          dispatch(
            getNotification({
              message: "Session expired! Please log in again",
              type: "default",
            })
          );
        } else {
          dispatch(
            getNotification({
              message: "Server is Down! Please try again after sometime",
              type: "default",
            })
          );
        }
      }
    } else {
      setTimeout(() => {
        UserService.doLogin({
          redirectUri: `${REACT_APP_REDIRECT_URI}/simulator`,
        });
      }, 1000);
    }
  };

  const handlescenariosfetch = async () => {
    if (UserService.isLoggedIn()) {
      try {
        const FormData = require("form-data");
        const sendData = new FormData();
        sendData.append("brand", selectedbrand)
        sendData.append("market", market)
        sendData.append("fy", selectedyear)
        const config = {
          method: "post",
          url: selectedbrand === "ATTA" ? `${REACT_APP_UPLOAD_DATA}/api/atta_get_scenario_names` : `${REACT_APP_UPLOAD_DATA}/api/get_scenario_names`,
          headers: {
            Accept: "text/plain",
            "Content-Type": "application/json",
            // "req-header":UserService.getToken()
          },
          data: sendData,
        };
        const getResponse = await axios(config);
        // console.log(getResponse)
        if (getResponse.data !== "Invalid User!") {
          setscenariooptions(getResponse.data?.filter(it => it.scenario_name !== "Base Scenario"))
          setresultscreen(true)
          handlefetchreferencescenario()
        }
      } catch (err) {
        console.log("Server Error", err);
        if (err.response && err.response.status === 500) {
          dispatch(
            getNotification({
              message: "Server is Down! Please try again after sometime",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 400) {
          dispatch(
            getNotification({
              message: "Input is not in prescribed format",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 422) {
          dispatch(
            getNotification({
              message: "Input is not in prescribed format",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 404) {
          dispatch(
            getNotification({
              message: "Page not Found",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 401) {
          dispatch(
            getNotification({
              message: "Session expired! Please log in again",
              type: "default",
            })
          );
        } else {
          dispatch(
            getNotification({
              message: "Server is Down! Please try again after sometime",
              type: "default",
            })
          );
        }
      }
    } else {
      setTimeout(() => {
        UserService.doLogin({
          redirectUri: `${REACT_APP_REDIRECT_URI}/simulator`,
        });
      }, 1000);
    }
  };
  const downloadSampleFile = async () => {
    if (timetype) {
      const fileUrl = `assets/Files/Sample${timetype}.xlsx`;
      const link = document.createElement('a');
      link.href = fileUrl;
      link.setAttribute('download', `samplefile${timetype}.xlsx`); // Set the name of the file for download
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link); // Clean up the DOM
    }
    else {
      dispatch(getNotification({
        message: "Please select tenure type!!",
        type: "danger"
      }))
    }
  }
  const scrollToTop = () => {
    if (sectionRef.current) {
      const yOffset = -50; // Adjust this value based on your preference
      const elementTop = sectionRef.current.offsetTop;
      const offsetPosition = elementTop + yOffset;

      window.scrollBy(500, 500);
      // window.scroll({
      //   top: offsetPosition,
      //   behavior: 'smooth',
      // });
    }
  };

  const fetchdatasettable = async (row) => {
    if (UserService.isLoggedIn()) {
      if (market && selectedbrand && market !== "Select" && selectedbrand !== "Select" && selectedyear && selectedyear !== "Select") {
        try {

          setloader2(true)
          const FormData = require("form-data");
          const sendData = new FormData();
          let config;
          sendData.append("scenario_name", row.scenario_name);
          sendData.append("scenario_timestamp", row.created_dt);
          sendData.append("user_id", "admin");
          sendData.append("final_market", market);
          sendData.append("brand", selectedbrand)
          sendData.append("fy", selectedyear)
          let getResponse = []
          let successfulResponse = []


          if (selectedscenarioname?.startsWith("Y_")) {
            config = {
              method: "post",
              url: `${REACT_APP_UPLOAD_DATA}/api/get_annual_scenario_data`,
              headers: {
                Accept: "text/plain",
                "Content-Type": "application/json",
              },
              data: sendData,
            }
          }
          else if (selectedscenarioname?.startsWith("Q_")) {
            config = {
              method: "post",
              url: `${REACT_APP_UPLOAD_DATA}/api/get_qtr_scenario_data`,
              headers: {
                Accept: "text/plain",
                "Content-Type": "application/json",
              },
              data: sendData,
            }
          }
          else if (selectedscenarioname?.startsWith("HY_")) {
            config = {
              method: "post",
              url: `${REACT_APP_UPLOAD_DATA}/api/get_hy_scenario_data`,
              headers: {
                Accept: "text/plain",
                "Content-Type": "application/json",
              },
              data: sendData,
            }
          }
          else {
            config = {
              method: "post",
              url: `${REACT_APP_UPLOAD_DATA}/api/getscenariodata`,
              headers: {
                Accept: "text/plain",
                "Content-Type": "application/json",
              },
              data: sendData,
            }
          }


          getResponse = await axios(config)




          if (getResponse?.data?.length > 0 && getResponse?.data[0] !== "No Records Found" && getResponse?.data[0].Error !== "Invalid User!"
          ) {

            setviewscenariodatatable(true)
            setresultscreen(true)
            //ifscenariogiven && setselectedscenarioname(ifscenariogiven)
            setdisplaynames2({
              ...displaynames2,
              brand: selectedbrand,
              scenario: selectedscenarioname,
              market: market,
              fy: selectedyear
            })
            setsampledataset(getResponse?.data)
            setoriginalset(getResponse?.data);
            setoriginaldatasetforcolorcoding(getResponse?.data)
          }

          else {

            dispatch(
              getNotification({
                message: `There is no valid data to display for selected brand and scenario combination`,
                type: "default",
              })

            );

            setresultscreen2(false)
          }



        } catch (err) {
          console.log("Server Error", err);

          if (err.response && err.response.status === 500) {
            dispatch(
              getNotification({
                message: "Server is Down! Please try again after sometime",
                type: "default",
              })
            );
          } else if (err.response && err.response.status === 400) {
            dispatch(
              getNotification({
                message: "Input is not in prescribed format",
                type: "default",
              })
            );
          } else if (err.response && err.response.status === 422) {
            dispatch(
              getNotification({
                message: "Input is not in prescribed format",
                type: "default",
              })
            );
          } else if (err.response && err.response.status === 404) {
            dispatch(
              getNotification({
                message: "Page not Found",
                type: "default",
              })
            );
          } else if (err.response && err.response.status === 401) {
            dispatch(
              getNotification({
                message: "Session expired! Please log in again",
                type: "default",
              })
            );
          } else {
            dispatch(
              getNotification({
                message: "Server is Down! Please try again after sometime",
                type: "default",
              })
            );
          }
        }
      }
      else {
        dispatch(
          getNotification({
            message: "Please select market to view scenario data!!",
            type: "danger",
          })
        );
      }
    } else {
      setTimeout(() => {
        UserService.doLogin({
          redirectUri: `${REACT_APP_REDIRECT_URI}/simulator`,
        });
      }, 1000);
    }

    setloader2(false);

    setTimeout(() => {
      scrollToSection("attributetable")

    }, 1000);


  };
  const fetchdatasettable2 = async () => {
    // console.log(selectedyear,market,selectedscenarioname,selectedbrand)
    if (UserService.isLoggedIn()) {
      if (market && selectedbrand && market !== "Select" && selectedbrand !== "Select") {
        try {
          setloader5(true)
          const FormData = require("form-data");
          const sendData = new FormData();
          let config;
          sendData.append("scenario_name", selectedscenarioname);
          sendData.append("scenario_timestamp", selectedscenarionametimestamp);
          sendData.append("user_id", "admin");
          sendData.append("final_market", market);
          sendData.append("brand", selectedbrand)
          if (selectedscenarioname === "Base Scenario") {
            if (timetype === "Y") {
              config = {
                method: "post",
                url: selectedbrand === "ATTA" ? `${REACT_APP_UPLOAD_DATA}/api/atta_annualbasegetscenariodata` : `${REACT_APP_UPLOAD_DATA}/api/annualbasegetscenariodata`,
                headers: {
                  Accept: "text/plain",
                  "Content-Type": "application/json",
                },
                data: sendData,
              };
            }
            else {
              config = {
                method: "post",
                url: selectedbrand === "ATTA" ? `${REACT_APP_UPLOAD_DATA}/api/atta_basegetscenariodata` : `${REACT_APP_UPLOAD_DATA}/api/basegetscenariodata`,
                headers: {
                  Accept: "text/plain",
                  "Content-Type": "application/json",
                },
                data: sendData,
              };

            }


          }

          else {
            if (selectedyear === "2025-26") {
              config = {
                method: "post",
                url: selectedbrand === "ATTA" ? `${REACT_APP_UPLOAD_DATA}/api/atta_getscenariodatayearly` : `${REACT_APP_UPLOAD_DATA}/api/get_annual_scenario_data`,
                headers: {
                  Accept: "text/plain",
                  "Content-Type": "application/json",
                },
                data: sendData,
              };
            }
            else {
              config = {
                method: "post",
                url: selectedbrand === "ATTA" ? `${REACT_APP_UPLOAD_DATA}/api/atta_getscenariodata` : `${REACT_APP_UPLOAD_DATA}/api/getscenariodata`,
                headers: {
                  Accept: "text/plain",
                  "Content-Type": "application/json",
                },
                data: sendData,
              };
            }

          }


          // Now you can use `config` without any errors
          const getResponse = await axios(config);

          if (getResponse.status === 200) {

            if (getResponse?.data?.length > 0 && getResponse?.data[0] !== "No Records Found" && getResponse?.data[0].Error !== "Invalid User!"
            ) {
              setcreatefrombaseoruploadfileswitch(false)
              setdisplaynames2({
                ...displaynames2,
                brand: selectedbrand,
                scenario: selectedscenarioname,
                market: market,
                fy: selectedyear

              })
              setsampledataset(getResponse?.data)
              setoriginalset(getResponse?.data);
              setviewscenariodatatable2(true)
              setoriginaldatasetforcolorcoding(getResponse?.data)

            }

            else {
              //console.log(scenariooptions[0].scenario_name)
              //  if (displaynames) {
              //    setselectedbrand(displaynames.brand || brandoptions[0].brand)
              //    setselectedscenarioname(displaynames.scenarioname || scenariooptions[0].scenario_name)
              //    setselectedzone(displaynames.zone || 'National')
              //    setselectedyear(displaynames.year || '2021-22')
              //    setselectedscenarioid(displaynames.id || scenariooptions[0].id)
              //  }
              // else{
              //   setselectedscenarioname(scenariooptions[0].scenario_name)
              //   setselectedscenarioid(scenariooptions[0].id)
              //   setselectedbrand(brandoptions[0]?.brand)
              //   setselectedzone('National')
              //   setselectedyear("2021-22")
              // }

              dispatch(
                getNotification({
                  message: `There is no valid data to display for selected brand and scenario combination`,
                  type: "default",
                })

              );
              //handleMouseEnter()
              setresultscreen2(false)
            }


          }
        } catch (err) {
          console.log("Server Error", err);
          // if (displaynames) {
          //   setselectedbrand(displaynames.brand || brandoptions[0].brand)
          //   setselectedscenarioname(displaynames.scenarioname || scenariooptions[0].scenario_name)
          //   setselectedyear(displaynames.fy || '2024-25')
          //   setmarket(displaynames.market || "Select")
          // }

          // else{
          //       setselectedscenarioname(scenariooptions[0].scenario_name)
          //       setselectedscenarioid(scenariooptions[0].id)
          //       setselectedbrand(brandoptions[0]?.brand)
          //       setselectedzone('National')
          //       setselectedyear('2021-22')
          // }
          //handleMouseEnter()
          if (err.response && err.response.status === 500) {
            dispatch(
              getNotification({
                message: "Server is Down! Please try again after sometime",
                type: "default",
              })
            );
          } else if (err.response && err.response.status === 400) {
            dispatch(
              getNotification({
                message: "Input is not in prescribed format",
                type: "default",
              })
            );
          } else if (err.response && err.response.status === 422) {
            dispatch(
              getNotification({
                message: "Input is not in prescribed format",
                type: "default",
              })
            );
          } else if (err.response && err.response.status === 404) {
            dispatch(
              getNotification({
                message: "Page not Found",
                type: "default",
              })
            );
          } else if (err.response && err.response.status === 401) {
            dispatch(
              getNotification({
                message: "Session expired! Please log in again",
                type: "default",
              })
            );
          } else {
            dispatch(
              getNotification({
                message: "Server is Down! Please try again after sometime",
                type: "default",
              })
            );
          }
        }
      }
      else {
        dispatch(
          getNotification({
            message: "Please select market to view scenario data!!",
            type: "danger",
          })
        );
      }
    } else {
      setTimeout(() => {
        UserService.doLogin({
          redirectUri: `${REACT_APP_REDIRECT_URI}/simulator`,
        });
      }, 1000);
    }
    setloader5(false);




  };
  const handlesimulate = async (row) => {
    if (UserService.isLoggedIn()) {
      // console.log(selectedyear,market,selectedscenarioname,selectedbrand)
      if (true) {
        try {
          setmodifybtn(false)
          setloader2(true);
          setviewscenariodatatable(false)
          const FormData = require("form-data");
          const sendData = new FormData();
          sendData.append("scenario_name", row.scenario_name);
          sendData.append("scenario_timestamp", row.created_dt);
          sendData.append("user_id", "admin");
          sendData.append("brand", selectedbrand);
          sendData.append("model_id", 1);
          sendData.append("market", market);
          sendData.append("f_year", selectedyear);

          const sendData2 = new FormData();


          const sendData3 = {
            brand: selectedbrand,
            market: [market]
          };
          let config1 = {}
          let config2 = {}
          if (row.scenario_name?.match("Master")) {
            // sendData2.append("scenario_name", 'Base Scenario');
            // sendData2.append("scenario_timestamp",'2025-01-12 15:54:05');
            sendData2.append("scenario_name", `${row?.scenario_name?.startsWith("M_") ? "M" : row?.scenario_name.startsWith("Y_") ? "Y" : row?.scenario_name.startsWith("Q_") ? "Q" : "HY"}_Base_Master_Scenario`,);
            sendData2.append("scenario_timestamp", "2025-01-12 15:54:05");
            sendData2.append("user_id", "admin");
            sendData2.append("market", market);
            sendData2.append("model_id", 1);
            sendData2.append("brand", selectedbrand);
            sendData2.append("f_year", selectedyear)

          }
          else {
            sendData2.append("scenario_name", 'Base Scenario');
            sendData2.append("scenario_timestamp", '2025-01-12 15:54:05');
            sendData2.append("user_id", "admin");
            sendData2.append("market", market);
            sendData2.append("model_id", 1);
            sendData2.append("brand", selectedbrand);
            sendData2.append("f_year", selectedyear)
          }

          // let config1 = {}
          // let config2 = {}
          if (row.scenario_name?.startsWith("Y_")) {
            config1 = {
              method: "post",
              url: `${REACT_APP_UPLOAD_DATA}/api/annual_predict`,
              headers: {
                Accept: "text/plain",
                "Content-Type": "application/json",
              },
              data: sendData,
            };
            config2 = {
              method: "post",
              url: `${REACT_APP_UPLOAD_DATA}/api/annual_basescenario_predict`,
              headers: {
                Accept: "text/plain",
                "Content-Type": "application/json",
              },
              data: sendData2,
            };
          }
          else if (row.scenario_name?.startsWith("Q_")) {
            config1 = {
              method: "post",
              url: `${REACT_APP_UPLOAD_DATA}/api/qtr_predict`,
              headers: {
                Accept: "text/plain",
                "Content-Type": "application/json",
              },
              data: sendData,
            };
            config2 = {
              method: "post",
              url: `${REACT_APP_UPLOAD_DATA}/api/base_qtr_predict`,
              headers: {
                Accept: "text/plain",
                "Content-Type": "application/json",
              },
              data: sendData2,
            };
          }
          else if (row.scenario_name?.startsWith("HY_")) {
            config1 = {
              method: "post",
              url: `${REACT_APP_UPLOAD_DATA}/api/hy_predict`,
              headers: {
                Accept: "text/plain",
                "Content-Type": "application/json",
              },
              data: sendData,
            };
            config2 = {
              method: "post",
              url: `${REACT_APP_UPLOAD_DATA}/api/base_hy_predict`,
              headers: {
                Accept: "text/plain",
                "Content-Type": "application/json",
              },
              data: sendData2,
            };
          }
          else {
            config1 = {
              method: "post",
              url: `${REACT_APP_UPLOAD_DATA}/api/predict`,
              headers: {
                Accept: "text/plain",
                "Content-Type": "application/json",
              },
              data: sendData,
            };
            config2 = {
              method: "post",
              url: selectedscenarioname?.match("Master") ? `${REACT_APP_UPLOAD_DATA}/api/base_predict` : `${REACT_APP_UPLOAD_DATA}/api/base_predict`,
              headers: {
                Accept: "text/plain",
                "Content-Type": "application/json",
              },
              data: sendData2,
            };
          }
          const getResponse2 = await axios(config2);
          const getResponse1 = await axios(config1);


          if (getResponse1.data.data) {
            if (getResponse1?.data?.data?.plot1?.length > 0) {

              setfulldataset(getResponse1?.data?.data)
              setfulldataset2(getResponse2?.data?.data)

              settorangeonplots(getResponse1?.data?.data?.plot1[getResponse1?.data?.data?.plot1.length - 1]?.month_year?.split("-").reverse()?.join("-"))
              let current_month_year = `${new Date().getFullYear()}-${(String(new Date().getMonth() + 1).padStart(2, "0"))}`;

              if (getResponse1?.data?.data?.plot1[0]?.month_year > current_month_year || row.scenario_name.startsWith("Y_")) {
                setfromrangeonplots(getResponse1?.data?.data?.plot1[0]?.month_year?.split("-").reverse()?.join("-"))
              } else {
                const [year, month] = endDate.split("-");
                const date = new Date(year, month); // Month is zero-based in JS Date
                const formattedDate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`;

                setfromrangeonplots(formattedDate?.split("-")?.reverse()?.join("-"))

              }

              setmodifybtn(false)

              setdisplaynames({
                ...displaynames,
                scenario: row.scenario_name,
                market: market,
                fy: selectedyear,
                brand: selectedbrand
              }
              )
              setresultscreen2(true);

              const currentDate = new Date();
              const currentYear = currentDate.getFullYear();
              const currentMonth = currentDate.getMonth() - 3; // getMonth() returns 0-indexed month
              const nextMonth = currentMonth === 12 ? 1 : currentMonth + 1;
              const nextYear = currentMonth === 12 ? currentYear + 1 : currentYear;


              setTimeout(() => {
                scrollToSection('simulateddata')
              }, 1000)

            }
            else {

              dispatch(
                getNotification({
                  message: "There is no data for selected options",
                  type: "default",
                })
              );
            }

            // setTimeout(() => {
            //   document.getElementById("SimulatorInputs").click()
            // }, 1000)
            scrollToTop();

            //settablegraphdataset(getResponse.data);


            //(getResponse.data)
          }
          else {
            dispatch(
              getNotification({
                message: "There is no data for selected options",
                type: "default",
              })
            );
          }
        } catch (err) {
          console.log("Server Error", err);
          if (err.response && err.response.status === 500) {
            dispatch(
              getNotification({
                message: "Server is Down! Please try again after sometime",
                type: "default",
              })
            );
          } else if (err.response && err.response.status === 400) {
            dispatch(
              getNotification({
                message: "Input is not in prescribed format",
                type: "default",
              })
            );
          } else if (err.response && err.response.status === 422) {
            dispatch(
              getNotification({
                message: "Input is not in prescribed format",
                type: "default",
              })
            );
          } else if (err.response && err.response.status === 404) {
            dispatch(
              getNotification({
                message: "Page not Found",
                type: "default",
              })
            );
          } else if (err.response && err.response.status === 401) {
            dispatch(
              getNotification({
                message: "Session expired! Please log in again",
                type: "default",
              })
            );
          } else {
            dispatch(
              getNotification({
                message: "Server is Down! Please try again after sometime",
                type: "default",
              })
            );
          }
        }
      } else {
        dispatch(
          getNotification({
            message: "Please fill all entries",
            type: "default",
          })
        );
      }
    } else {
      setTimeout(() => {
        UserService.doLogin({
          redirectUri: `${REACT_APP_REDIRECT_URI}/simulator`,
        });
      }, 1000);
    }
    setloader2(false)

  };
  function getCurrentFormattedTime() {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }






  const [modelcallibrationoptions, setmodelcallibrationoptions] = useState([
    { label: "test", value: "test" }
  ]);





  const [openindex, setopenindex] = useState([])
  useEffect(() => {

    handlevariablesfetchfybrand()
    handlevariablesfetch();
  }, []);

  useEffect(() => {
    handlefetchmarket()
  }, [selectedbrand])



  const handlefetchreferencescenario = async () => {
    if (UserService.isLoggedIn()) {
      try {

        const FormData = require("form-data");
        const sendData = new FormData();
        sendData.append("fy", selectedyear)
        sendData.append("brand", selectedbrand)
        sendData.append("market", market)

        // sendData.append("scenario_timestamp",selectedscenarionametimestamp)
        const config = {
          method: "post",
          url: `${REACT_APP_UPLOAD_DATA}/api/get_new_base_scenario_names`,
          headers: {
            Accept: "text/plain",
            "Content-Type": "application/json",
            // "req-header":UserService.getToken()
          },
          data: sendData,
        };



        const getResponse = await axios(config);



        if (getResponse.data !== "Invalid User!") {
          //console.log(referencescenarioname.filter((it)=>"M_APTG_23".charAt(0)===it?.frequency))
          // settotalBudget(getResponse.data[0].budget)
          let selectedyrsplit = selectedyear?.split("-")
          let arr = getResponse?.data?.filter((it) => Number(it?.fy?.split("-")[0]) - 1 === Number(selectedyrsplit[0]) && Number(it?.fy?.split("-")[1]) - 1 === Number(selectedyrsplit[1]))
          // console.log(arr[0]?.scenario_name.replace(`M_NEW_BASE_`,""))
          //  setreferencescenarioname(arr[0]?.scenario_name.replace(`M_NEW_BASE_`,""))
          setreferencescenarioname(getResponse?.data?.filter((it) => Number(it?.fy?.split("-")[0]) - 1 === Number(selectedyrsplit[0]) && Number(it?.fy?.split("-")[1]) - 1 === Number(selectedyrsplit[1])))

        }
      } catch (err) {
        console.log("Server Error", err);
        if (err.response && err.response.status === 500) {
          dispatch(
            getNotification({
              message: "Server is Down! Please try again after sometime",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 400) {
          dispatch(
            getNotification({
              message: "Input is not in prescribed format",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 422) {
          dispatch(
            getNotification({
              message: "Input is not in prescribed format",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 404) {
          dispatch(
            getNotification({
              message: "Page not Found",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 401) {
          dispatch(
            getNotification({
              message: "Session expired! Please log in again",
              type: "default",
            })
          );
        } else {
          dispatch(
            getNotification({
              message: "Server is Down! Please try again after sometime",
              type: "default",
            })
          );
        }
      }
    } else {
      setTimeout(() => {
        UserService.doLogin({
          redirectUri: `${REACT_APP_REDIRECT_URI}/savedscenarios`,
        });
      }, 1000);
    }
  };
  const handlemodifyreferencecenarios = async (row) => {
    if (UserService.isLoggedIn()) {
      try {
        setloader5(true)
        const FormData = require("form-data");
        const sendData5 = new FormData();
        let config5;
        sendData5.append("scenario_name", row.scenario_name);
        sendData5.append("scenario_timestamp", row.created_dt);
        sendData5.append("user_id", "admin");
        sendData5.append("final_market", market);
        sendData5.append("brand", selectedbrand)
        sendData5.append("fy", selectedyear)
        let getResponse5 = []
        let successfulResponse = []


        if (selectedscenarioname?.startsWith("Y_")) {
          config5 = {
            method: "post",
            url: `${REACT_APP_UPLOAD_DATA}/api/get_annual_scenario_data`,
            headers: {
              Accept: "text/plain",
              "Content-Type": "application/json",
            },
            data: sendData5,
          }
        }
        else if (selectedscenarioname?.startsWith("Q_")) {
          config5 = {
            method: "post",
            url: `${REACT_APP_UPLOAD_DATA}/api/get_qtr_scenario_data`,
            headers: {
              Accept: "text/plain",
              "Content-Type": "application/json",
            },
            data: sendData5,
          }
        }
        else if (selectedscenarioname?.startsWith("HY_")) {
          config5 = {
            method: "post",
            url: `${REACT_APP_UPLOAD_DATA}/api/get_hy_scenario_data`,
            headers: {
              Accept: "text/plain",
              "Content-Type": "application/json",
            },
            data: sendData5,
          }
        }
        else {
          config5 = {
            method: "post",
            url: `${REACT_APP_UPLOAD_DATA}/api/getscenariodata`,
            headers: {
              Accept: "text/plain",
              "Content-Type": "application/json",
            },
            data: sendData5,
          }
        }


        getResponse5 = await axios(config5)


        const requestData = {
          // "scenario_name": `${displaynames?.scenario?.startsWith("M_") ? "M" : displaynames?.scenario.startsWith("Y_") ? "Y" : displaynames?.scenario.startsWith("Q_") ? "Q" : "HY"}_Base_Master_Scenario`,
          scenario_name: `${row?.scenario_name.charAt(0)}_NEW_BASE_${row?.scenario_name}`,
          "scenario_timestamp": row.created_dt,
          "user_id": "admin",
          "model_id": 1,
          "fy": selectedyear,
          "dataset": getResponse5?.data

        };
        const config = {
          method: "post",
          url: `${REACT_APP_UPLOAD_DATA}/api/save_new_base_scenario`,
          headers: {
            Accept: "text/plain",
            "Content-Type": "application/json",
            // "req-header":UserService.getToken()
          },
          data: requestData,
        };
        const requestData2 =
        {
          scenario_name: `M_NEW_BASE_${row?.scenario_name}`,
          "scenario_timestamp": row.created_dt,
          "user_id": "admin",
          final_market: market,
          "brand": selectedbrand,
          "fy": `${Number(selectedyear.split("-")[0]) + 1}-${Number(selectedyear.split("-")[1]) + 1}`
        }


        const config2 = {
          method: "post",
          url: `${REACT_APP_UPLOAD_DATA}/api/monthly_to_annual_new_base`,
          headers: {
            Accept: "text/plain",
            "Content-Type": "application/json",
            // "req-header":UserService.getToken()
          },
          data: requestData2,
        };
        const requestData3 =
        {
          scenario_name: `M_NEW_BASE_${row?.scenario_name}`,
          "scenario_timestamp": row.created_dt,
          "user_id": "admin",
          final_market: market,
          "brand": selectedbrand,
          "fy": `${Number(selectedyear.split("-")[0]) + 1}-${Number(selectedyear.split("-")[1]) + 1}`
        }


        const config3 = {
          method: "post",
          url: `${REACT_APP_UPLOAD_DATA}/api/monthly_to_qtr_new_base`,
          headers: {
            Accept: "text/plain",
            "Content-Type": "application/json",
            // "req-header":UserService.getToken()
          },
          data: requestData3,
        };
        const requestData4 =
        {
          scenario_name: `M_NEW_BASE_${row?.scenario_name}`,
          "scenario_timestamp": row.created_dt,
          "user_id": "admin",
          final_market: market,
          "brand": selectedbrand,
          "fy": `${Number(selectedyear.split("-")[0]) + 1}-${Number(selectedyear.split("-")[1]) + 1}`
        }


        const config4 = {
          method: "post",
          url: `${REACT_APP_UPLOAD_DATA}/api/monthly_to_hy_new_base
        `,
          headers: {
            Accept: "text/plain",
            "Content-Type": "application/json",
            // "req-header":UserService.getToken()
          },
          data: requestData4,
        };
        const getResponse = await axios(config);
        const getResponse2 = await axios(config2);
        const getResponse3 = await axios(config3);
        const getResponse4 = await axios(config4);

        if (getResponse.data) {

          handlefetchreferencescenario()
          //setreferencescenarioname(getResponse)
          //settotalBudget(budgetfromcell)

        }
      } catch (err) {
        console.log("Server Error", err);
        if (err.response && err.response.status === 500) {
          dispatch(
            getNotification({
              message: "Server is Down! Please try again after sometime",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 400) {
          dispatch(
            getNotification({
              message: "Input is not in prescribed format",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 422) {
          dispatch(
            getNotification({
              message: "Input is not in prescribed format",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 404) {
          dispatch(
            getNotification({
              message: "Page not Found",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 401) {
          dispatch(
            getNotification({
              message: "Session expired! Please log in again",
              type: "default",
            })
          );
        } else {
          dispatch(
            getNotification({
              message: "Server is Down! Please try again after sometime",
              type: "default",
            })
          );
        }
      }
    } else {
      setTimeout(() => {
        UserService.doLogin({
          redirectUri: `${REACT_APP_REDIRECT_URI}/savedscenarios`,
        });
      }, 1000);
    }
    setloader5(false)
  };
  const handledeletescenarios = async (row) => {
    if (UserService.isLoggedIn()) {
      try {
        setloader5(true)
        const FormData = require("form-data");
        const sendData = new FormData();
        const currenttime = getCurrentFormattedTime()

        const FormData2 = require("form-data");
        const sendData2 = new FormData2();

        sendData2.append("scenario_name", row.scenario_name);
        sendData2.append("scenario_timestamp", row.created_dt);

        let config2 = {}
        if (row.scenario_name?.startsWith("Y_")) {
          config2 = {
            method: "post",
            url: `${REACT_APP_UPLOAD_DATA}/api/delete_annual_scenario`,
            headers: {
              Accept: "text/plain",
              "Content-Type": "application/json",
            },
            data: sendData2,
          }
        }
        else if (row.scenario_name?.startsWith("Q_")) {
          config2 = {
            method: "post",
            url: `${REACT_APP_UPLOAD_DATA}/api/delete_qtr_scenario`,
            headers: {
              Accept: "text/plain",
              "Content-Type": "application/json",
            },
            data: sendData2,
          }
        }
        else if (row.scenario_name?.startsWith("HY_")) {
          config2 = {
            method: "post",
            url: `${REACT_APP_UPLOAD_DATA}/api/delete_hy_scenario`,
            headers: {
              Accept: "text/plain",
              "Content-Type": "application/json",
            },
            data: sendData2,
          }
        }
        else {
          config2 = {
            method: "post",
            url: `${REACT_APP_UPLOAD_DATA}/api/delete_monthly_scenario`,
            headers: {
              Accept: "text/plain",
              "Content-Type": "application/json",
            },
            data: sendData2,
          }
        }

        const getResponse2 = await axios(config2);


        if (getResponse2.status === 200) {

          handlescenariosfetch()
          //setreferencescenarioname(getResponse)
          //settotalBudget(budgetfromcell)

        }
      } catch (err) {
        console.log("Server Error", err);
        if (err.response && err.response.status === 500) {
          dispatch(
            getNotification({
              message: "Server is Down! Please try again after sometime",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 400) {
          dispatch(
            getNotification({
              message: "Input is not in prescribed format",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 422) {
          dispatch(
            getNotification({
              message: "Input is not in prescribed format",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 404) {
          dispatch(
            getNotification({
              message: "Page not Found",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 401) {
          dispatch(
            getNotification({
              message: "Session expired! Please log in again",
              type: "default",
            })
          );
        } else {
          dispatch(
            getNotification({
              message: "Server is Down! Please try again after sometime",
              type: "default",
            })
          );
        }
      }
    } else {
      setTimeout(() => {
        UserService.doLogin({
          redirectUri: `${REACT_APP_REDIRECT_URI}/savedscenarios`,
        });
      }, 1000);
    }
    setloader5(false)
  };
  const handleCheckboxChange = (index, row) => {
    // If the clicked checkbox is the same as the currently selected one, uncheck it
    if (openindex[index] === true) {
      let arr = []
      setopenindex(arr)
    }
    else {

      handlesimulate(row);

      let arr = []
      arr[index] = true;
      setopenindex(arr)

    }
    // Call the analysis function

  };






  const handlevariablesfetch = async () => {
    if (UserService.isLoggedIn()) {
      try {
        const FormData = require("form-data");
        const sendData = new FormData();
        const config = {
          method: "get",
          url: `${REACT_APP_UPLOAD_DATA}/app/fetchvars`,
          headers: {
            Accept: "text/plain",
            "Content-Type": "application/json",
            // "req-header":UserService.getToken()
          },
          data: sendData,
        };
        const getResponse = await axios(config);
        if (getResponse.data !== "Invalid User!") {
          setStartDate(getResponse.data.dates[0].min[0].start_date);
          setEndDate(getResponse.data.dates[0].max[0].end_date);


        }
      } catch (err) {
        console.log("Server Error", err);
        if (err.response && err.response.status === 500) {
          dispatch(
            getNotification({
              message: "Server is Down! Please try again after sometime",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 400) {
          dispatch(
            getNotification({
              message: "Input is not in prescribed format",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 422) {
          dispatch(
            getNotification({
              message: "Input is not in prescribed format",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 404) {
          dispatch(
            getNotification({
              message: "Page not Found",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 401) {
          dispatch(
            getNotification({
              message: "Session expired! Please log in again",
              type: "default",
            })
          );
        } else {
          dispatch(
            getNotification({
              message: "Server is Down! Please try again after sometime",
              type: "default",
            })
          );
        }
      }
    } else {
      setTimeout(() => {
        UserService.doLogin({
          redirectUri: `${REACT_APP_REDIRECT_URI}/brandanalysis`,
        });
      }, 1000);
    }
  };



  return (
    <>
      <Navbar3 />
      <div className="bgpages">
        <div className=' mx-4 py-3'>
          <div className='breadcrumb '>{`Dashboard >> Saved Scenarios`}</div>
          <div className='pageheading d-flex justify-content-between align-items-center my-2 px-3 py-2 ' style={{ fontSize: "20px" }}>
            <b> Saved Scenarios</b>
            {resultscreen &&
              <div>
                <button className="btn btn-orange  mx-2 my-auto"
                  onClick={() => {
                    setselectedscenarioname("");
                    setresultscreen(false);
                    setmarket("");
                    setselectedbrand("");
                    setmodifybtn(false);
                    setopenindex([])
                  }}
                >
                  Reset
                </button>
                <button className="btn btn-info fw-semibold" style={{ color: 'black' }} onClick={() => setmodifybtn(!modifybtn)}>
                  {modifybtn ? 'Close' : 'Modify'}
                </button>
              </div>
            }
          </div>
          {modifybtn && (
            <div className="card shadow-sm border-0 p-4 my-3 rounded-4 bg-light">
              <h6 className="fw-bold text-dark mb-3">
                <i className="bi bi-sliders me-2 text-primary"></i>Modify Filters
              </h6>

              <div className="row g-3">
                {/* FY */}
                <div className="col-12 col-md-6 col-lg-3">
                  <label className="form-label fw-semibold text-secondary">
                    FY <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-select shadow-sm border-0 rounded-3 py-2"
                    value={selectedyear}
                    onChange={(e) => {
                      setselectedyear(e.target.value);
                      setselectedbrand("");
                      setmarket("");
                      setselectedscenarioname("");
                    }}
                  >
                    <option value="">Select</option>
                    {yearoptions?.map((item) => (
                      <option key={item.fy}>{item.fy}</option>
                    ))}
                  </select>
                </div>

                {/* Brand */}
                <div className="col-12 col-md-6 col-lg-3">
                  <label className="form-label fw-semibold text-secondary">
                    Brand <span className="text-danger">*</span>
                  </label>
                  <select
                    value={maskedBrandOption.maskedBrandOption[selectedbrand]}
                    className="form-select shadow-sm border-0 rounded-3 py-2"
                    onChange={(e) => {
                      setselectedbrand(
                        unMaskedBrandOption.unMaskedBrandOption[e.target.value]
                      );
                      setmarket("Select");
                      setselectedscenarioname("Select");
                      setviewscenariodatatable(false);
                      setviewscenariodatatable2(false);
                      setmodifybtn(false);
                      setresultscreen2(false);
                      setresultscreen(false);
                    }}
                  >
                    <option value="">Select</option>
                    {brandoptions?.map((option) => (
                      <option key={option.brand}>
                        {maskedBrandOption.maskedBrandOption[option.brand]}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Market */}
                <div className="col-12 col-md-6 col-lg-3">
                  <label className="form-label fw-semibold text-secondary">
                    Market <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-select shadow-sm border-0 rounded-3 py-2"
                    value={market}
                    onChange={(e) => {
                      setmarket(e.target.value);
                      setselectedscenarioname("Select");
                      setviewscenariodatatable(false);
                      setviewscenariodatatable2(false);
                      setmodifybtn(false);
                      setresultscreen2(false);
                      setresultscreen(false);
                    }}
                  >
                    <option value="">Select</option>
                    {marketoptions?.map((item) => (
                      <option key={item.final_market}>{item.final_market}</option>
                    ))}
                  </select>
                </div>

                {/* Fetch Button */}
                {selectedscenarioname !== "Base Scenario" && (
                  <div className="col-12 col-md-6 col-lg-3 d-flex align-items-end">
                    <button
                      id="subm"
                      className="btn btn-primary w-100 py-2 shadow-sm fw-semibold"
                      onClick={() => handlescenariosfetch()}
                    >
                      <i className="bi bi-download me-2"></i>Fetch Scenarios
                    </button>
                  </div>
                )}
              </div>
            </div>
          )}

          {resultscreen ?
            loader ? (
              <div
                className="row d-flex  justify-content-center align-items-center "
                style={{ height: "75vh" }}
              >
                <Loader
                  type="box-rectangular"
                  bgColor={"#0A4742"}
                  title={"Processing Plots..."}
                  color={"#0A4742"}
                  size={75}
                />
              </div>) : <div className=" ">



              {scenariooptions?.length > 0 ?
                <div className="container-fluid">
                  <table className="text-center table table-sm my-4 table-striped shadow table-bordered table-responsive-md col-sm-12 mx-auto" style={{ fontSize: "12px" }}>
                    <thead>
                      <tr>
                        <th>S. No.</th>
                        <th>FY</th>
                        <th>Brand</th>
                        <th>Market</th>
                        <th>Scenario Name</th>
                        <th>Date Created</th>
                        <th>Select for More Details</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(() => {
                        const references = scenariooptions?.filter((row) =>
                          referencescenarioname.some(
                            (master) => row.scenario_name === master.scenario_name.replace("M_NEW_BASE_", "")
                          )
                        );

                        const others = scenariooptions?.filter((row) =>
                          !referencescenarioname.some(
                            (master) => row.scenario_name === master.scenario_name.replace("M_NEW_BASE_", "")
                          )
                        );

                        // Sort the other rows by created_dt in descending order
                        const sortedOthers = others.sort(
                          (a, b) => new Date(b.created_dt) - new Date(a.created_dt)
                        );

                        // Combine masters and sorted others
                        const combined = [...references, ...sortedOthers];

                        return combined.map((row, index) => (
                          <>
                            <tr>
                              <td>{index + 1}</td>
                              <td>{selectedyear}</td>
                              <td>{selectedbrand}</td>
                              <td>{market}</td>
                              <td>{row?.scenario_name}</td>
                              <td>{row?.created_dt?.split("T")[0]}</td>
                              <td>
                                <span
                                  onClick={() => {
                                    setfulldataset({});
                                    setfulldataset2({});
                                    handleCheckboxChange(index, row);
                                  }}
                                >
                                  <button className="btn btn-sm p-0">
                                    {openindex[index] === true ? "Hide" : "More Details"}
                                  </button>
                                </span>
                              </td>
                              <td>
                                {loader5 ? (
                                  "Loading..."
                                ) : (
                                  row?.scenario_name.startsWith("M_") && <button
                                    onClick={() => {
                                      if (
                                        row?.scenario_name ===
                                        referencescenarioname.filter(
                                          (it) => it.fy === selectedyear
                                        )[0]?.scenario_name
                                      ) {
                                      } else {
                                        handlemodifyreferencecenarios(row);
                                      }
                                    }}
                                    className={
                                      row?.scenario_name ===
                                        referencescenarioname[0]?.scenario_name.replace(`M_NEW_BASE_`, "")
                                        ? "btn btn-sm text-success mx-1 "
                                        : "btn btn-sm btn-secondary mx-1"
                                    }
                                  >
                                    {
                                      row?.scenario_name ===
                                        referencescenarioname[0]?.scenario_name.replace(`M_NEW_BASE_`, "")
                                        ? <b>Reference</b>
                                        : "Set as Reference"}
                                  </button>
                                )}
                                {row?.scenario_name ===
                                  referencescenarioname[0]?.scenario_name.replace(`M_NEW_BASE_`, "") ?
                                  "" :
                                  <button className="btn btn-sm" onClick={() => { handledeletescenarios(row) }}>
                                    <i
                                      className="fas fa-trash-alt "
                                      style={{ color: "grey", fontSize: "16px" }}
                                    ></i>
                                  </button>}
                              </td>
                            </tr>
                            {openindex[index] === true && (
                              <tr>
                                <td colSpan="10" className="p-3">
                                  {loader2
                                    ? "Loading..."
                                    : fulldataset?.plot1.length > 0 ? (
                                      <div>


                                        <div className="d-flex flex-row-reverse my-2">
                                          <button className="btngreentheme p-2 " onClick={() => setisValue(!isValue)}>{isValue ? "By Volume" : "By Value"}</button>
                                        </div>
                                        <div className="card " id="simulateddata">

                                          {displaynames?.fy !== "2025-26" ? fulldataset?.plot1?.length > 0 && fulldataset2?.plot1?.length > 0 &&
                                            <LineChart1 displaynames={displaynames} fulldataset1={fulldataset} fulldataset2={fulldataset2} isValue={isValue}
                                              range={`${formatDate(fromrangeonplots)}-${formatDate(torangeonplots)}`} /> :
                                            <AnnualData displaynames={displaynames} fulldataset1={fulldataset} fulldataset2={fulldataset2} isValue={isValue} range={`${formatDate(fromrangeonplots)}-${formatDate(torangeonplots)}`} />
                                          }
                                        </div>
                                        <div className="row my-3">
                                          {fulldataset2?.plot2?.length > 0 &&
                                            <div className="card col-sm mx-1 p-2" id="" >



                                              <PieCharts isValue={isValue} range={`${formatDate(fromrangeonplots)}-${formatDate(torangeonplots)}`} fulldataset={fulldataset2} type={`${row?.scenario_name?.match("Master") ? "Master" : "Base"} Scenario`} displaynames={displaynames} />

                                            </div>
                                          }
                                          {fulldataset?.plot2?.length > 0 && <div className="card col-sm mx-1 p-2" id="" >



                                            <PieCharts isValue={isValue} range={`${formatDate(fromrangeonplots)}-${formatDate(torangeonplots)}`} fulldataset={fulldataset} type={displaynames.scenario} />



                                          </div>}

                                        </div>
                                        <div className="row my-3">
                                          {fulldataset2?.plot3?.length > 0 && <div className="card col-sm mx-1 p-2" id="" >

                                            <SingleBarChart1 fulldataset={fulldataset2} type={`${row?.scenario_name?.match("Master") ? "Master" : "Base"} Scenario`} isValue={isValue} range={`${formatDate(fromrangeonplots)}-${formatDate(torangeonplots)}`}
                                              maxValuedynamicVolume={Math.ceil(Math.max(...[
                                                fulldataset?.plot3[0].total_core / 1000,
                                                fulldataset?.plot3[1].total_incremental / 1000,
                                                fulldataset?.plot3[2].total_media / 1000,
                                                fulldataset2?.plot3[0].total_core / 1000,
                                                fulldataset2?.plot3[1].total_incremental / 1000,
                                                fulldataset2?.plot3[2].total_media / 1000,
                                              ]) / 100) * 100}
                                              maxValuedynamicValue={Math.ceil(Math.max(...[
                                                fulldataset?.plot3[0].total_core_sales / 100000,
                                                fulldataset?.plot3[1].total_incremental_sales / 100000,
                                                fulldataset?.plot3[2].total_media_sales / 100000,
                                                fulldataset2?.plot3[0].total_core_sales / 100000,
                                                fulldataset2?.plot3[1].total_incremental_sales / 100000,
                                                fulldataset2?.plot3[2].total_media_sales / 100000,
                                              ]) / 100) * 100
                                              } />


                                          </div>}
                                          {fulldataset?.plot3?.length > 0 && <div className="card col-sm mx-1 p-2" id="" >

                                            <SingleBarChart1 fulldataset={fulldataset} type={displaynames.scenario} isValue={isValue} range={`${formatDate(fromrangeonplots)}-${formatDate(torangeonplots)}`}
                                              maxValuedynamicVolume={Math.ceil(Math.max(...[
                                                fulldataset?.plot3[0].total_core / 1000,
                                                fulldataset?.plot3[1].total_incremental / 1000,
                                                fulldataset?.plot3[2].total_media / 1000,
                                                fulldataset2?.plot3[0].total_core / 1000,
                                                fulldataset2?.plot3[1].total_incremental / 1000,
                                                fulldataset2?.plot3[2].total_media / 1000,
                                              ]) / 100) * 100}
                                              maxValuedynamicValue={Math.ceil(Math.max(...[
                                                fulldataset?.plot3[0].total_core_sales / 100000,
                                                fulldataset?.plot3[1].total_incremental_sales / 100000,
                                                fulldataset?.plot3[2].total_media_sales / 100000,
                                                fulldataset2?.plot3[0].total_core_sales / 100000,
                                                fulldataset2?.plot3[1].total_incremental_sales / 100000,
                                                fulldataset2?.plot3[2].total_media_sales / 100000,
                                              ]) / 100) * 100
                                              } />

                                          </div>}
                                        </div>
                                        <div className="row my-3">
                                          {fulldataset2?.plot4?.length > 0 && <div className="card col-sm mx-1 p-2" id="" >

                                            <SingleBarChart2 fulldataset={fulldataset2} type={`${row?.scenario_name?.match("Master") ? "Master" : "Base"} Scenario`} isValue={isValue} range={`${formatDate(fromrangeonplots)}-${formatDate(torangeonplots)}`}
                                              maxValuedynamicVolume={Math.ceil(
                                                Math.max(...fulldataset?.plot4.map((it) => it.contribution), ...fulldataset2?.plot4.map((it) => it.contribution)

                                                ) / 100
                                              ) * 100}
                                              maxValuedynamicValue={Math.ceil(
                                                Math.max(...fulldataset?.plot4.map((it) => it.contribution_sales_value / 100000, ...fulldataset2?.plot4.map((it) => it.contribution_sales_value / 100000))

                                                ) / 100
                                              ) * 100} />

                                          </div>}
                                          {fulldataset?.plot4?.length > 0 && <div className="card col-sm mx-1 p-2" id="" >

                                            <SingleBarChart2 fulldataset={fulldataset} type={displaynames.scenario} isValue={isValue} range={`${formatDate(fromrangeonplots)}-${formatDate(torangeonplots)}`}
                                              maxValuedynamicVolume={Math.ceil(
                                                Math.max(...fulldataset?.plot4.map((it) => it.contribution), ...fulldataset2?.plot4.map((it) => it.contribution)

                                                ) / 100
                                              ) * 100}
                                              maxValuedynamicValue={Math.ceil(
                                                Math.max(...fulldataset?.plot4.map((it) => it.contribution_sales_value / 100000, ...fulldataset2?.plot4.map((it) => it.contribution_sales_value / 100000))

                                                ) / 100
                                              ) * 100} />

                                          </div>}

                                        </div>
                                        <div className="row my-3">
                                          {fulldataset2?.plot10?.length > 0 && <div className="card col-sm mx-1 p-2" id="" >

                                            <SingleBarChart5 fulldataset={fulldataset2} type={`${row?.scenario_name?.match("Master") ? "Master" : "Base"} Scenario`} isValue={isValue} range={`${formatDate(fromrangeonplots)}-${formatDate(torangeonplots)}`}
                                              maxValuedynamicVolume={Math.ceil(
                                                Math.max(...fulldataset?.plot10.map((it) => it.contribution), ...fulldataset?.plot10.map((it) => it.contribution)

                                                ) / 100
                                              ) * 100}
                                              maxValuedynamicValue={Math.ceil(
                                                Math.max(...fulldataset?.plot10.map((it) => it.contribution_sales_value / 100000), ...fulldataset2?.plot10.map((it) => it.contribution_sales_value / 100000)

                                                ) / 100
                                              ) * 100} />


                                          </div>}
                                          {fulldataset?.plot10?.length > 0 && <div className="card col-sm mx-1 p-2" id="" >

                                            <SingleBarChart5 fulldataset={fulldataset} type={displaynames.scenario} isValue={isValue} range={`${formatDate(fromrangeonplots)}-${formatDate(torangeonplots)}`}
                                              maxValuedynamicVolume={Math.ceil(
                                                Math.max(...fulldataset?.plot10.map((it) => it.contribution), ...fulldataset?.plot10.map((it) => it.contribution)

                                                ) / 100
                                              ) * 100}
                                              maxValuedynamicValue={Math.ceil(
                                                Math.max(...fulldataset?.plot10.map((it) => it.contribution_sales_value / 100000), ...fulldataset2?.plot10.map((it) => it.contribution_sales_value / 100000)

                                                ) / 100
                                              ) * 100} />


                                          </div>}

                                        </div>

                                        <div className="row my-3">
                                          {fulldataset2?.plot9?.length > 0 && <div className="card col-sm mx-1 p-2" id="" >

                                            <SingleBarChart4 fulldataset={fulldataset2} type={`${row?.scenario_name?.match("Master") ? "Master" : "Base"} Scenario`} isValue={isValue} range={`${formatDate(fromrangeonplots)}-${formatDate(torangeonplots)}`}
                                              maxValuedynamicVolume={
                                                Math.ceil(Math.max(
                                                  ...fulldataset?.plot5?.map((it) => { return Number(it?.attribute_value_per_roi) }), ...fulldataset2?.plot5?.map((it) => { return Number(it?.attribute_value_per_roi) })
                                                ))
                                              }
                                            />


                                          </div>}
                                          {fulldataset?.plot9?.length > 0 && <div className="card col-sm mx-1 p-2" id="" >

                                            <SingleBarChart4 fulldataset={fulldataset} type={displaynames.scenario} isValue={isValue} range={`${formatDate(fromrangeonplots)}-${formatDate(torangeonplots)}`}
                                              maxValuedynamicVolume={
                                                Math.ceil(Math.max(
                                                  ...fulldataset?.plot5?.map((it) => { return Number(it?.attribute_value_per_roi) }), ...fulldataset2?.plot5?.map((it) => { return Number(it?.attribute_value_per_roi) })
                                                ))
                                              } />


                                          </div>}

                                        </div>
                                        <div className="row my-3">
                                          {fulldataset2?.plot13?.length > 0 && <div className="card col-sm mx-1 p-2" id="" >

                                            <SingleBarChart8 fulldataset={fulldataset2} type={`${row?.scenario_name?.match("Master") ? "Master" : "Base"} Scenario`} isValue={isValue} range={`${formatDate(fromrangeonplots)}-${formatDate(torangeonplots)}`}
                                              maxValuedynamicVolume={
                                                Math.ceil(Math.max(
                                                  ...fulldataset?.plot13?.map((it) => { return Number(it?.attribute_value_per_roi) }), ...fulldataset2?.plot13?.map((it) => { return Number(it?.attribute_value_per_roi) })
                                                ) / 10) * 10
                                              } />


                                          </div>}
                                          {fulldataset?.plot13?.length > 0 && <div className="card col-sm mx-1 p-2" id="" >

                                            <SingleBarChart8 fulldataset={fulldataset} type={displaynames.scenario} isValue={isValue} range={`${formatDate(fromrangeonplots)}-${formatDate(torangeonplots)}`}
                                              maxValuedynamicVolume={
                                                Math.ceil(Math.max(
                                                  ...fulldataset?.plot13?.map((it) => { return Number(it?.attribute_value_per_roi) }), ...fulldataset2?.plot13?.map((it) => { return Number(it?.attribute_value_per_roi) })
                                                ) / 10) * 10
                                              } />


                                          </div>}
                                        </div>
                                        <div className="row my-3">
                                          {fulldataset2?.plot12?.length > 0 && <div className="card col-sm mx-1 p-2" id="" >

                                            <SingleBarChart7 fulldataset={fulldataset2} type={`${row?.scenario_name?.match("Master") ? "Master" : "Base"} Scenario`} isValue={isValue} range={`${formatDate(fromrangeonplots)}-${formatDate(torangeonplots)}`}
                                              maxValuedynamicVolume={
                                                Math.ceil(Math.max(
                                                  ...fulldataset?.plot12?.map((it) => { return Number(it?.attribute_value_per_roi) }), ...fulldataset?.plot12?.map((it) => { return Number(it?.attribute_value_per_roi) })
                                                ))
                                              } />


                                          </div>}
                                          {fulldataset?.plot12?.length > 0 && <div className="card col-sm mx-1 p-2" id="" >

                                            <SingleBarChart7 fulldataset={fulldataset} type={displaynames.scenario} isValue={isValue} range={`${formatDate(fromrangeonplots)}-${formatDate(torangeonplots)}`}
                                              maxValuedynamicVolume={
                                                Math.ceil(Math.max(
                                                  ...fulldataset?.plot12?.map((it) => { return Number(it?.attribute_value_per_roi) }), ...fulldataset?.plot12?.map((it) => { return Number(it?.attribute_value_per_roi) })
                                                ))
                                              } />


                                          </div>}

                                        </div>

                                        <div className="row my-3">
                                          {fulldataset2?.plot11?.length > 0 && <div className="card col-sm mx-1 p-2" id="" >

                                            <SingleBarChart6 fulldataset={fulldataset2} type={`${row?.scenario_name?.match("Master") ? "Master" : "Base"} Scenario`} isValue={isValue} range={`${formatDate(fromrangeonplots)}-${formatDate(torangeonplots)}`}
                                              maxValuedynamicVolume={
                                                Math.ceil(Math.max(
                                                  ...fulldataset?.plot11?.map((it) => { return Number(it?.effectiveness) }), ...fulldataset2?.plot11?.map((it) => { return Number(it?.effectiveness) })
                                                ) / 10) * 10
                                              } />


                                          </div>}
                                          {fulldataset?.plot11?.length > 0 && <div className="card col-sm mx-1 p-2" id="" >

                                            <SingleBarChart6 fulldataset={fulldataset} type={displaynames.scenario} isValue={isValue} range={`${formatDate(fromrangeonplots)}-${formatDate(torangeonplots)}`}
                                              maxValuedynamicVolume={
                                                Math.ceil(Math.max(
                                                  ...fulldataset?.plot11?.map((it) => { return Number(it?.effectiveness) }), ...fulldataset2?.plot11?.map((it) => { return Number(it?.effectiveness) })
                                                ) / 10) * 10
                                              } />


                                          </div>}

                                        </div>
                                        <div className="row my-3">
                                          {fulldataset2?.plot5?.length > 0 && <div className="card col-sm mx-1 p-2" id="" >

                                            <SingleBarChart3 fulldataset={fulldataset2} type={`${row?.scenario_name?.match("Master") ? "Master" : "Base"} Scenario`} isValue={isValue} range={`${formatDate(fromrangeonplots)}-${formatDate(torangeonplots)}`}
                                              maxValuedynamicVolume={
                                                Math.ceil(Math.max(
                                                  ...fulldataset?.plot9?.map((it) => { return Number(it?.effectiveness) }), ...fulldataset2?.plot9?.map((it) => { return Number(it?.effectiveness) })
                                                ) / 10) * 10
                                              } />


                                          </div>}
                                          {fulldataset?.plot5?.length > 0 && <div className="card col-sm mx-1 p-2" id="" >

                                            <SingleBarChart3 fulldataset={fulldataset} type={displaynames.scenario} isValue={isValue} range={`${formatDate(fromrangeonplots)}-${formatDate(torangeonplots)}`}
                                              maxValuedynamicVolume={
                                                Math.ceil(Math.max(
                                                  ...fulldataset?.plot9?.map((it) => { return Number(it?.effectiveness) }), ...fulldataset2?.plot9?.map((it) => { return Number(it?.effectiveness) })
                                                ) / 10) * 10
                                              } />


                                          </div>}

                                        </div>











                                      </div>

                                    ) : (
                                      <div>There was some problem generating charts!</div>
                                    )}
                                </td>
                              </tr>
                            )}
                          </>
                        ));
                      })()}



                    </tbody>

                  </table>
                </div>
                :
                <div className="alert alert-warning text-center fw-semibold rounded-3 shadow-sm py-3">
                  <i className="bi bi-exclamation-circle me-2"></i>
                  No records found to display.
                </div>

              }

            </div> :
            loader ? (
              <div
                className="row d-flex  justify-content-center align-items-center "
                style={{ height: "75vh" }}
              >
                <Loader
                  type="box-rectangular"
                  bgColor={"#0A4742"}
                  title={"Processing Plots..."}
                  color={"#0A4742"}
                  size={75}
                />
              </div>) :
              <>
                <div className="container-fluid my-3">
                  {brandoptions?.length > 0 ? (
                    <div className="card shadow-sm border-0 rounded-3 p-4">
                      {/* === Filters Section === */}
                      <div className="row g-3 align-items-end">
                        {/* FY Filter */}
                        <div className="col-12 col-md-3">
                          <label className="fw-bold mb-1">
                            FY:<span className="text-danger">*</span>
                          </label>
                          <select
                            className="form-select"
                            onChange={(e) => {
                              setviewscenariodatatable(false);
                              setselectedyear(e.target.value);
                              setselectedbrand("");
                              setmarket("");
                              setselectedscenarioname("");
                            }}
                            value={selectedyear}
                          >
                            <option>Select</option>
                            {yearoptions?.map((item) => (
                              <option key={item.fy}>{item.fy}</option>
                            ))}
                          </select>
                        </div>

                        {/* Brand Filter */}
                        <div className="col-12 col-md-3">
                          <label className="fw-bold mb-1">
                            Brand:<span className="text-danger">*</span>
                          </label>
                          <select
                            className="form-select"
                            value={maskedBrandOption.maskedBrandOption[selectedbrand]}
                            onChange={(e) => {
                              setselectedbrand(unMaskedBrandOption.unMaskedBrandOption[e.target.value]);
                              setmarket("Select");
                              setselectedscenarioname("Select");
                              setviewscenariodatatable(false);
                            }}
                          >
                            <option>Select</option>
                            {brandoptions?.map((option) => (
                              <option key={option.brand}>{maskedBrandOption.maskedBrandOption[option.brand]}</option>
                            ))}
                          </select>
                        </div>

                        {/* Market Filter */}
                        <div className="col-12 col-md-3">
                          <label className="fw-bold mb-1">
                            Market:<span className="text-danger">*</span>
                          </label>
                          <select
                            className="form-select"
                            onChange={(e) => {
                              setmarket(e.target.value);
                              setselectedscenarioname("Select");
                              setviewscenariodatatable(false);
                            }}
                            value={market}
                          >
                            <option>Select</option>
                            {marketoptions?.map((item) => (
                              <option key={item.final_market}>{item.final_market}</option>
                            ))}
                          </select>
                        </div>

                        {/* Fetch Button */}
                        <div className="col-12 col-md-3 text-md-end text-center mt-3 mt-md-0">
                          <div
                            className="submitfrmtbtn"
                            type="button"
                            onClick={() => handlescenariosfetch()}
                          >
                            <span>
                              Fetch Scenarios{" "}
                              <iconify-icon icon="iconamoon:arrow-right-2-bold"></iconify-icon>
                            </span>
                          </div>
                        </div>
                      </div>

                      {/* === Time Type Selection (Radio Buttons) === */}
                      {scenarionewoldscreen === "new" && (
                        <div className="mt-4 border-top pt-3">
                          <h6 className="fw-semibold mb-3">Select Time Type:</h6>
                          <div className="d-flex flex-wrap gap-3">
                            {[
                              { label: "Yearly", value: "Y" },
                              { label: "Half-Yearly", value: "HY" },
                              { label: "Quarterly", value: "Q" },
                              { label: "Monthly", value: "M" },
                            ].map((item, index) => (
                              <div className="form-check" key={index}>
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="timetype"
                                  id={`time-${item.value}`}
                                  onClick={() => {
                                    settimetype(item.value);
                                    setviewscenariodatatable(false);
                                  }}
                                />
                                <label
                                  className="form-check-label fw-semibold"
                                  htmlFor={`time-${item.value}`}
                                >
                                  {item.label}
                                </label>
                              </div>
                            ))}
                          </div>

                          {/* Buttons Under Time Type */}
                          <div className="d-flex flex-wrap align-items-center mt-4 gap-3">
                            {timetype && (
                              <>
                                <button
                                  className="btn btn-dark"
                                  onClick={() => {
                                    if (viewscenariodatatable) {
                                      setviewscenariodatatable(false);
                                    } else {
                                      fetchdatasettable("Base Scenario");
                                    }
                                  }}
                                >
                                  {!viewscenariodatatable
                                    ? "Create from Base Scenario Data"
                                    : "Hide"}
                                </button>

                                <span style={{ fontSize: "20px" }}>/</span>

                                <button
                                  className="btn btn-dark"
                                  onClick={() =>
                                    setcreatefrombaseoruploadfileswitch(
                                      !createfrombaseoruploadfileswitch
                                    )
                                  }
                                >
                                  Import from Excel
                                </button>
                              </>
                            )}
                          </div>

                          {/* === Upload File Section === */}
                          {createfrombaseoruploadfileswitch && (
                            <div className="mt-4 border-top pt-3">
                              <div className="row g-3 align-items-end">
                                <div className="col-12 col-md-5">
                                  <label className="fw-bold mb-1">
                                    Import File <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="file"
                                    accept=".xlsx"
                                    onChange={(e) => setuploadfile(e.target.files[0])}
                                    className="form-control"
                                    placeholder="No File Chosen"
                                  />
                                  <ul className="list-unstyled small mt-2">
                                    <li
                                      type="button"
                                      className="text-primary"
                                      onClick={() => downloadSampleFile()}
                                      style={{ cursor: "pointer" }}
                                    >
                                      <iconify-icon icon="material-symbols:download"></iconify-icon>{" "}
                                      Download Sample File
                                    </li>
                                    <li className="text-muted">(File Type: Excel & CSV)</li>
                                  </ul>
                                </div>

                                <div className="col-12 col-md-2">
                                  <div className="uploadbtn text-center">
                                    <a>Upload</a>
                                  </div>
                                </div>

                                <div className="col-12 col-md-2">
                                  <div className="resetbtn text-center">
                                    <a
                                      onClick={() => {
                                        setresultscreen(false);
                                        setresultscreen2(false);
                                        setselectedbrand("");
                                        setmarket("");
                                      }}
                                    >
                                      Reset
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      )}

                      {/* === Old Scenario Simulate Button === */}
                      {scenarionewoldscreen === "old" &&
                        selectedscenarioname !== "Base Scenario" && (
                          <div className="text-end mt-4">
                            <div
                              className="submitfrmtbtn"
                              type="button"
                              onClick={() => handlesimulate()}
                            >
                              <span>
                                Simulate{" "}
                                <iconify-icon icon="iconamoon:arrow-right-2-bold"></iconify-icon>
                              </span>
                            </div>
                          </div>
                        )}
                    </div>
                  ) : (
                    <div className="my-3 d-flex flex-column align-items-center justify-content-center py-5" style={{ backgroundColor: "white" }}>
                      <div className="dot-loader">
                        <div></div><div></div><div></div>
                      </div>
                      <div className="mt-2 fw-semibold text-muted">Grabbing Details...</div>
                    </div>
                  )}
                </div>

              </>}

          <div></div>
        </div>
      </div>






      <div className='' >
        <FooterPages />
      </div>
    </>

  )
}

export default SavedScenarios